export default __webpack_public_path__ + "static/googletagmanager-b8113aaba2ea7db8a5dab33fbb133a47.png";